import axios from "axios";
import { getApiBaseUrl } from "../config/apiBase";
import { CMS_ADMIN_TOKEN } from "../utils/storageKeys";

const axiosClient = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    Accept: "application/json",
  },
});

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(CMS_ADMIN_TOKEN);

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (config.data && !(config.data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json";
  }

  return config;
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(CMS_ADMIN_TOKEN);
      localStorage.removeItem("cms_admin_user");
      if (!window.location.pathname.startsWith("/cmsadmin")) {
        window.location.href = "/cmsadmin";
      } else if (!window.location.pathname.endsWith("/cmsadmin")) {
        window.location.href = "/cmsadmin";
      }
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
